import { Component, OnInit, EventEmitter } from '@angular/core';
import { BaseComponent } from 'src/modules/shared/base.component';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from 'src/environments/environment';
import { PageEvent } from '@angular/material/paginator';
import { Store, IRegularBooking, LoadBooking, SpinnerLoaded, SpinnerLoading, StoreBookingType, SaveSeason, StoreAssets, ClearStore } from 'src/modules/store/regular-booking/index';
import { ICart } from 'src/modules/store/index';

import { Observable } from "rxjs";
import { RegualrBookingService } from 'src/modules/services/regular-booking.service';
import { AssetService } from 'src/modules/services/asset.service';

import { RegularBookingSettings } from 'src/modules/models/settings/regular-portal/regular-booking-setting';
//model
import { Booking } from 'src/modules/models/regular-portal/booking/booking';
import { BookingPackage } from 'src/modules/models/regular-portal/booking/booking-package';
import { Tree, TreeNode } from 'src/modules/regular-booking/wp-calendar/calendar/tree-data';
import { AdHocDocument } from 'src/modules/models/booking/adhoc-document';
import { Allocation } from 'src/modules/models/regular-portal/booking/save-booking/allocations';
import { Timeslot } from 'src/modules/models/regular-portal/booking/save-booking/timeslot';
import { Asset } from 'src/modules/models/regular-portal/booking/save-booking/Asset';
import { EventConfiguration } from 'src/modules/models/booking/event-configuration';
import { Package } from 'src/modules/models/booking/package';
import { PackageService } from 'src/modules/services/package.service';
import { Facility } from '../models/asset/facility';
//save
import { Booking as BookingS, BookingPackage as BookingPackageS, Contact, Client } from 'src/modules/models/regular-portal/booking/save-booking/booking';
import { BookingItem as BookingItemS, Item } from 'src/modules/models/regular-portal/booking/save-booking/booking-item';
import { Item as Items } from "src/modules/models/item/item";
import { RecurrenceOption } from 'src/modules/models/regular-portal/recurrence-option';
import { RegularBookingAdapter } from 'src/modules/models/regular-portal/regular-booking-adapter';
//helper classes
import { Utility } from 'src/modules/utility';
import { CalendarUtil, DAYS_OF_WEEK } from 'src/modules/regular-booking/wp-calendar/calendar/calendar-util';

///Date
import * as _moment from 'moment';
import { default as _rollupMoment } from 'moment';
import { MomentDateAdapter } from 'src/modules/booking-portal/common/date-time-adapter/moment-date-adapter';

//common
import { cacheUtility } from 'src/modules/cache-utillity';

import { VenueAssetsearchparams, Page } from 'src/modules/models/regular-portal/venue-assets-search-param';

import { EventView } from 'src/modules/regular-booking/wp-calendar/calendar/week-view';
import { DateFormat } from '../date-format';
import { ProductItemFilters } from '../models/product/product-item-filters';


const moment = _rollupMoment || _moment;


@Component({
    selector: 'opt-rb-booking-common',
    template: ''
})

export class BookingCommonComponent extends BaseComponent implements OnInit {
    rbStore$: Observable<IRegularBooking>;
    cart$: Observable<ICart>;
    booking: Booking
    seasonId: number;
    venueList: TreeNode[] = [];
    seasonName: string;
    bookingId: string;
    recurrentOption: RecurrenceOption;
    bookingType: any;
    contact: Contact;
    selectedStepIndex: number = 0;
    _BookingTypedefaultConcessionId: any;
    listSaleCategories: any[] = [0];
    clientSaleCategories: any[] = [];
    $bookingLoad = new EventEmitter();
    isLoggedIn: boolean;
    showErrorMessage: boolean = false;
    displayMessage: string;
    ApiUrl: string;
    isLoading: boolean = false;
    listDataAsset: any;
    assetIdArray: any[] = [];
    //selectedList: any[] = [];
    searchstring: string = "";
    listVenuids: any[] = [];
    locationPageSize: number = 0;
    addedDocuments: AdHocDocument[];
    events: EventView[] = [];
    availableDocumentCategories: string[] = [];
    requiredDocumentCategories: string[] = [];
    documentCategoryHeader: string;
    _regularXmlData = (environment.RegularBookingSetting as RegularBookingSettings);
    isRolloverBooking: boolean;
    rbStoreData: IRegularBooking;
    assetDataFromStore: any;
    clientPriceConcessionId: any;
    bookingTypeId: string = "0";
    displayFacilityConfigurations: boolean;
    configList: any[] = [];
    selectedConfig: any;
    configurationToBeListed: any = [];
    SelectedList: TreeNode[] = [];
    configurations = [];
    // SelectedMultiPurposeAssetList: any[] = [];
    bookingLoading: boolean = false;
    isCreatingBooking: boolean = false;

    constructor(protected _store: Store<any>, private route: ActivatedRoute,
        private regBookingService: RegualrBookingService, public _assetService: AssetService, public _packageService?: PackageService) {
        super();
        this.rbStore$ = _store.select('rbStore');
        this.cart$ = _store.select('cart');
        this.ApiUrl = environment.ApiUrl;

        this.isRolloverBooking = Boolean(Number(this.route.snapshot.queryParams["rolloverBooking"]));

    }
    ngOnInit() {
        this._store.dispatch(new SpinnerLoaded());

        this.rbStore$.safeSubscribe(this, state => {
            this.populateStoreData(state);
            this.rbStoreData = state;
            // console.log('booking data from common store', this.booking);
        });

        this.cart$.safeSubscribe(this, state => {
            if (state.contact) {
                this.contact = new Contact();
                this.contact.id = state.contact.id
                this.contact.client = new Client();
                if (state.contact.client)
                    this.contact.client.id = state.contact.client.id;
                this.populateContactData(state);
            }

            // console.log('booking data from common store', this.booking);
        });


        this.$bookingLoad.safeSubscribe(this, (res: Booking) => {
            if (res && this.contact && res.contact) {

                if ((this.contact?.id != res.contact?.id)) {
                    window.open(this.ApiUrl + '#/bookings', "_self");
                }
            }

            const regularSetting = environment.RegularBookingSetting as RegularBookingSettings;
            if (res && res.bookingTypeId) {
                let _bookingType = regularSetting.booking.bookingTypes.find(bk => bk.id == String(res.bookingTypeId));
                if (res.bookingStatus.id != _bookingType.bookingWorkFlow.draftBookingStatusId) {
                    window.open(this.ApiUrl + '#/bookings', "_self");
                }
            }

            //this.LoadStepper(res);
        });

        /*  this.bookingId = this.route.snapshot.queryParams["bookingId"];
         if (this.route.snapshot.queryParams["OpenBooking"]) {
             this.bookingId = this.route.snapshot.queryParams["OpenBooking"];
         }

         if (!this.booking || this.booking == null || this.bookingId != this.booking.id) {
             if (this.bookingId) {
                 if (!this.bookingLoading) {
                     this.bookingLoading = true;
                     this._store.dispatch(new ClearStore());
                     this.LoadBooking(this.bookingId, this.$bookingLoad, true);
                 }
             }
         } else {
             this.selectedStepIndex = 1;

         } */


        this.cart$.safeSubscribe(this, state => {
            //   console.log('regular booking store', state);
            this.contact = state.contact;

        });



    }
    filterAvailableDocumentCategories() {
        if (this.bookingType && this.bookingType.availableDocumentCategories)
            this.availableDocumentCategories = this.bookingType.availableDocumentCategories.split(",");

        if (this.bookingType && this.bookingType.requiredDocumentCategories)
            this.requiredDocumentCategories = this.bookingType.requiredDocumentCategories.split(",");

        if (this.bookingType) {
            this.documentCategoryHeader = this.bookingType.documentCategoryHeader;

        }
    }
    loadAddedBookingDocuments(eventEmitter: EventEmitter<any> = null) {
        if (this.booking && this.booking.id) {
            this._store.dispatch(new SpinnerLoading());
            this.regBookingService.getBookingDocuments(this.booking.id).safeSubscribe(this,
                response => {
                    if (this.bookingType && this.bookingType.availableDocumentCategories) {
                        this.availableDocumentCategories = this.bookingType?.availableDocumentCategories?.split(",");
                    }

                    /* const categoryIds = this.availableDocumentCategories.map(cat => cat);*/

                    let filteredDocuments = response;
                    if (this.availableDocumentCategories.length > 0) {
                        filteredDocuments = response.filter(doc =>
                            this.availableDocumentCategories.includes(doc.documentCategoryId.toString())
                        );
                    }
                    eventEmitter.emit(filteredDocuments);
                },
                error => {
                    console.log(error);
                    this._store.dispatch(new SpinnerLoaded());
                },
                () => {
                    this._store.dispatch(new SpinnerLoaded());
                    console.log('documentTemplateCategories loaded')
                }
            );
        }
    }
    populateContactData(state: ICart) {
        this.isLoggedIn = (state.contact != null && state.contact.firstName != null && state.contact.firstName != "") ? true : false;
        this.clientPriceConcessionId = (this.isLoggedIn) ? (state.contact.client.priceConcessionId != "") ? state.contact.client.priceConcessionId : null : null;
        //clientvenueId
        if (state.contact.clientVenueIds) {
            var assignedids = [];
            for (let res of state.contact.clientVenueIds) {
                assignedids.push(res.id);
            }
            this.listVenuids = assignedids;


        }

    }

    populateCartDetails(state) {
        if (state.bookingPackage) {
            var SaleCategories = state.bookingPackage.salesCategories;
            this.clientSaleCategories = SaleCategories;
        }
        if (state.contact.clientVenueIds) {
            var assignedids = [];
            for (let res of state.contact.clientVenueIds) {
                assignedids.push(res.id);
            }
            this.listVenuids = assignedids;
        }
    }
    populateStoreData(state: IRegularBooking) {
        if (state) {
            this.booking = state.booking;
            this.seasonId = state.seasonId;
            this.bookingType = state.BookingType;
            this.recurrentOption = state.recurrentOption;
            this.venueList = state.AssetList;
            this.isLoading = state.isLoading;
            this.locationPageSize = state.locationPageSize;
            if (state.BookingType) {
                this.bookingTypeId = state.BookingType.id;
            }
            if (state.BookingType && state.seasonId) {

                let _seasons = state.BookingType.seasons.find((e) => e.id == state.seasonId.toString());
                if (_seasons)
                    this.seasonName = _seasons.name;
            }
            if (this.bookingType) {
                this.filterAvailableDocumentCategories();
                this.FacilityConfiguration();
            }
        }
    }

    LoadStepper() {
        // this._store.dispatch(new SpinnerLoading());

        var _SelectedList = [];
        this.assetIdArray
        if (this.booking && this.booking.id) {
            if (this.booking.bookingTypeId != null || this.booking.bookingTypeId != undefined) {
                var _regularXmlData = (environment.RegularBookingSetting as RegularBookingSettings)
                this.bookingType = _regularXmlData.booking.bookingTypes.find(typ => Number(typ.id) == this.booking.bookingTypeId);
                if (this.bookingType) {
                    this._store.dispatch(new StoreBookingType(this.bookingType));
                } else {
                    window.open(environment.CasualBookingPortalUrl, "_self");
                }
            }
            if (this.booking.seasonId) {
                if (this.booking.seasonId) {
                    //if (environment.RegularBookingSetting != undefined) {
                    //    var _seasonCaraousalData = (environment.RegularBookingSetting as RegularBookingSettings);
                    //    if (_seasonCaraousalData != undefined && this.booking.bookingTypeId != undefined) {
                    //        //find the bookingType
                    //        let _findBookingType = _seasonCaraousalData.booking.bookingTypes.find(bkType => bkType.id == String(this.booking.bookingTypeId));
                    //        if (_findBookingType) {
                    //            //find the Season
                    //            const _findSeason = _findBookingType.seasons.find(s => s.id == String(this.booking.seasonId));
                    //            if (_findSeason) {
                    //                var currentDate = moment().format('YYYY-MM-DD');
                    //                if (_findSeason.cutoffDate && _findSeason.cutoffDate != "") {
                    //                    if (new Date(currentDate) <= new Date(_findSeason.cutoffDate)) {
                    //                        this._store.dispatch(new SaveSeason(this.booking.seasonId));
                    //                    };
                    //                } else {
                    //                    if (_findSeason.to && _findSeason.to !="") {
                    //                        if (new Date(currentDate) <= new Date(_findSeason.to)) {
                    //                            this._store.dispatch(new SaveSeason(this.booking.seasonId));
                    //                        };
                    //                    }

                    //                }

                    //            };
                    //        }
                    //    }
                    //};
                    this._store.dispatch(new SaveSeason(this.booking.seasonId));
                } else {
                    this.selectedStepIndex = 0;
                }
            }
            const regularSetting = environment.RegularBookingSetting as RegularBookingSettings;
            if (regularSetting.booking.locationCacheTime) {
                const _validCacheAssets = cacheUtility.fetch(this.booking.id, regularSetting.booking.locationCacheTime)

                if (_validCacheAssets != null) {
                    this._store.dispatch(new StoreAssets(_validCacheAssets));
                  /*  if (!this.isRolloverBooking && this.bookingTypeId != '-4') {
                        this.selectedStepIndex = 2;
                    } else {
                        this.selectedStepIndex = 1;
                    }*/
                     this.selectedStepIndex = 2;
                    return;
                } else {

                    if (this.bookingTypeId == '-4') {
                        this.cacheLocations(this.listVenuids, this.listSaleCategories, "", 0, 0, 0, 0, this.NavigateStepperAfterCacheAssets);
                        return;
                    }
                }
            }
            //   this.selectedList = [];
            if (this.booking.bookingPackages && this.booking.bookingPackages.length > 0) {

                //this.selectedStepIndex = 1;
                this.booking.bookingPackages.forEach((pk, i) => {
                    if (pk.bookingVenues != undefined && pk.bookingVenues.length > 0) {
                        pk.bookingVenues.forEach((bk, pkIndex) => {
                            //Array pushing
                            let _selectedVenue: TreeNode;
                            if (_SelectedList) {
                                _selectedVenue = _SelectedList.find(sl => sl.id == bk.venue.id);
                            };

                            if (!_selectedVenue) {
                                _selectedVenue =
                                {
                                    label: bk.venue.name, id: bk.venue.id, data: null, selectable: false, parentId: null,
                                    children: []
                                }
                                _SelectedList.push(_selectedVenue);
                            };


                            if (_selectedVenue) {
                                //BookingItem foreach for assets
                                bk.bookingItem.forEach((bkItem, bkindex) => {
                                    //Assets forEach
                                    if (bkItem) {
                                        //temp fix to booking item doe snot have venue
                                        if (bkItem.item.venue == null || bkItem.item.venue == undefined) {
                                            bkItem.item.venue = bk.venue;
                                        }
                                        const _isMultiPurposeAsset = (bkItem.multiPurposeAssetIds ?? "") != "";
                                        bkItem.asset.forEach((ast, asIndex) => {
                                            if (ast != undefined) {

                                                let findAsset = _SelectedList.find(sl => (_isMultiPurposeAsset ? ((sl.data?.multiPurposeAssetIds ?? "") == bkItem.multiPurposeAssetIds) : (sl.id == ast.id)));
                                                if (!findAsset) {

                                                    let _findSlectedAsset = _selectedVenue.children.find(aset => (_isMultiPurposeAsset ? (aset.data["multiPurposeAssetIds"] == bkItem.multiPurposeAssetIds) : (aset.id == ast.id)));
                                                    if (!_findSlectedAsset) {
                                                        _selectedVenue.children.push(
                                                            {
                                                                label: ast.name, id: ast.id, children: [], data: {
                                                                    multiPurposeAssetIds: bkItem.multiPurposeAssetIds,
                                                                }, selectable: true, parentId: _selectedVenue.id
                                                            }
                                                        );
                                                    }

                                                }
                                            }
                                            //chcek asset assing preiously
                                            if (this.assetIdArray.length > 0) {
                                                var findAsset = this.assetIdArray.find(as => as == ast.id);
                                                if (!findAsset) {
                                                    this.assetIdArray.push(ast.id);
                                                }
                                            } else {

                                                this.assetIdArray.push(ast.id);
                                            }

                                        });
                                    }
                                });
                            }
                        });

                    };
                    //if (pk.bookingItem && pk.bookingItem.length > 0) {
                    //    pk.bookingItem.forEach((bkitm, index) => {
                    //        bkitm.asset.forEach((aset, i) => {
                    //            if (aset.id)
                    //                _assetIdArray.push(aset.id);
                    //        });
                    //    });
                    //
                    //}
                });

                this.getFacilityAndResources([], 0, this.searchstring, this.listVenuids, "", 0, 0, this.assetIdArray.join(), _SelectedList); //  From: number = 0;    To: number = 0;



                //store assetData
                if (this.assetIdArray.length > 0) {
                    //        this.getFacilityAndResource(this.listVenuids, this.listSaleCategories, "", 0, 0, 0, 0);
                }

            } else {
                this.selectedStepIndex = 0;
            }



        } else {
            //handle booking save error
        }




    }



    populateBookingItems(bookingId, selectedTab, recOption, assetData, addHocDates) {
        var booking = new BookingS();
        booking.id = bookingId;

        booking.bookingPackages = [];

        let bpkge = new BookingPackageS();
        bpkge.id = assetData.bookingPackage.id;
        bpkge.bookingItems = [];
        let _team;
        if (this.booking && this.booking.bookingPackages) {
            _team = this.booking.bookingPackages.find(p => p.id == assetData.bookingPackage.id);
        }
        booking.bookingPackages.push(bpkge);
        if (selectedTab == 1) {

            let bookingItem = new BookingItemS();
            if (assetData.event.id != undefined) {
                bookingItem.id = assetData.event.id;
            } else if (assetData.event && assetData.event.BookingItemIds.length > 0) {
                bookingItem.id = assetData.event.BookingItemIds[0];
            } else {
                bookingItem.id = '-1';
                bookingItem.recurrent = true;
                bookingItem.upsell = true;
                bookingItem.quantity = 1;
                if (_team) {
                    bookingItem.covers = _team.attendees;
                    bookingItem.attendees = _team.attendees;

                    if (assetData?.assets?.multiPurposeAssetIds == "") {
                        bookingItem.allocations = new Allocation();
                        bookingItem.allocations = this.getAllocation(assetData, _team, recOption.startTime, recOption.endTime);
                    }


                }
            }

            bookingItem.item = new Item();

            if (assetData.event.treeNode) {
                bookingItem.item.id = assetData.event.treeNode.data.selectedItem.id;
                bookingItem.item.type = assetData.event.treeNode.data.selectedItem.type;
            }
            else {
                /*when editing from side panel or edit booking*/
                bookingItem.item.id = assetData.event.item.id;
                bookingItem.item.type = assetData.event.item.type;
            }

            bookingItem.type = 'privateBooking' + bookingItem.item.type;
            bookingItem.recurrenceOption = recOption;


            bpkge.bookingItems.push(bookingItem);

            //add hoc}}
        } else {
            let incrementNumber: number = 0;
            addHocDates.forEach((date, index) => {
                incrementNumber = incrementNumber - 1;
                let bookingItem = new BookingItemS();
                let convertHours = CalendarUtil.MinToHours(assetData.event.startMin);
                // let momendate = moment(date.startTime).format()
                let res = CalendarUtil.GetStartEndTime(convertHours, assetData.event.durationMin, date.startTime);
                bookingItem.id = (incrementNumber).toString();
                bookingItem.recurrent = false;
                bookingItem.adhoc = true;
                bookingItem.upsell = true;
                bookingItem.startTime = Utility.convertToISO(Utility.appendTimePart(moment(res.startTime).toDate(), moment(res.startTime).toDate(), true));
                bookingItem.endTime = Utility.convertToISO(Utility.appendTimePart(moment(res.endTime).toDate(), moment(res.endTime).toDate(), true));
                bookingItem.item = new Item();
                if (assetData.event.treeNode) {

                    // for change configuration changes elected item is pushed in to data items[0]
                    bookingItem.item.id = assetData.event.treeNode.data.selectedItem.id;
                    bookingItem.item.type = assetData.event.treeNode.data.selectedItem.type;

                    // bookingItem.item.id = assetData.event.treeNode.selectedItem.id;
                    // bookingItem.item.type = assetData.event.treeNode.selectedItem.type;
                }
                //else {
                //    bookingItem.item.id = assetData.event.item.id;
                //    bookingItem.item.type = assetData.event.item.type;
                //}
                bookingItem.type = 'privateBooking' + bookingItem.item.type;
                bookingItem.quantity = 1
                if (_team) {
                    bookingItem.covers = _team.attendees;
                    bookingItem.attendees = _team.attendees;

                    if (assetData?.assets?.multiPurposeAssetIds == "") {
                        bookingItem.allocations = new Allocation();
                        bookingItem.allocations = this.getAllocation(assetData, _team, bookingItem.startTime, bookingItem.endTime);
                    }
                }

                bpkge.bookingItems.push(bookingItem);
            })

        }
        return booking;
    }
    getBookingItem(items, _findBookingPackage) {

        var _item = new Item();
        items.forEach((itm, itmIndex) => {

            if (itm.validateSalesCategory != 2) {
                if (itm && itm.salesCategories) {
                    let _findAssetChildren = itm.salesCategories.findIndex(sales =>
                        (_findBookingPackage.salesCategories && _findBookingPackage.salesCategories.findIndex(s => s.id == sales.id) >= 0));

                    if (_findAssetChildren >= 0) {
                        return _item = itm;
                    }
                }
            }
        });
        return _item;
    }
    SaveBooking(booking, eventEmitter: EventEmitter<any> = null, isStopLoading = false, rolloverBookingid = "0", isRolloverBookingDocument = false) {
        this._store.dispatch(new SpinnerLoading());
        this.regBookingService.SaveBooking(booking, rolloverBookingid, isRolloverBookingDocument).safeSubscribe(this,
            response => {

                if (response && response.body && response.body.isError) {
                    this.isCreatingBooking = false;
                    this._store.dispatch(new SpinnerLoaded());
                    if (eventEmitter) {
                        //eventEmitter.emit(response.body.errors[0].detail);

                        // in handlesuucessfailure from tye body errors are extracted sp np need tp extract here and send
                        eventEmitter.emit(response.body);
                    }
                    return;
                }
                var res;
                var minDate = "";
                var maxDate = "";

                this._packageService.privatePackages(0, minDate, maxDate).subscribe(data => {
                    if (data.length > 0) {
                        this.isCreatingBooking = false;
                        var bespokePackages = data;
                        res = RegularBookingAdapter.RemoveConcatination(response, bespokePackages);
                        if (eventEmitter)
                            eventEmitter.emit(res);
                        if (isStopLoading || (response && response.status != 200))
                            this._store.dispatch(new SpinnerLoaded());
                    }
                    else {
                        this.isCreatingBooking = false;
                        if (eventEmitter)
                            eventEmitter.emit(response);
                        if (isStopLoading || (response && response.status != 200))
                            this._store.dispatch(new SpinnerLoaded());
                    }
                });
            },
            error => {
                this.isCreatingBooking = false;
                if (eventEmitter)
                    eventEmitter.emit(error)
                this._store.dispatch(new SpinnerLoaded());
            },
            () => {
                this.isCreatingBooking = false;
                //console.log('Booking Patch Done')
            }
        );
    }


    SaveQuestions(questionToPatch, eventEmitter: EventEmitter<any> = null) {
        this.regBookingService.QuestionSavePatch(this.booking.id, questionToPatch).safeSubscribe(this, response => {
            console.log(response);
            /*if (eventEmitter) {
                eventEmitter.emit(response)
              /!*this.LoadBooking(this.booking.id, eventEmitter, true)*!/
            }*/
            if (eventEmitter && eventEmitter instanceof EventEmitter) {
                eventEmitter.emit(response);

            }
        },
            error => {
                this.showErrorMessage = true;
                this.displayMessage = error;
                console.log(error)
            },
            () => { console.log("data are returning from this point") }
        );
    }
    LoadBooking(bookingId, eventEmitter: EventEmitter<any> = null, reloadStore = false, bookingRollover = false) {
        if (bookingId) {
            this._store.dispatch(new SpinnerLoading());
            this.regBookingService.SelectBooking(bookingId).safeSubscribe(this, result => {
                if (bookingRollover == false && result != undefined)

                    var res;
                var minDate = "";
                var maxDate = "";

                this._packageService.privatePackages(0, minDate, maxDate).subscribe(data => {
                    if (data.length > 0) {
                        var bespokePackages = data;
                        res = RegularBookingAdapter.RemoveConcatination(result, bespokePackages);
                        this._store.dispatch(new LoadBooking(res));
                        this._store.dispatch(new SpinnerLoaded());

                        if (eventEmitter)
                            eventEmitter.emit(res)
                        if (reloadStore) {
                            this.LoadStepper();
                        }
                    }
                    else {
                        if (eventEmitter)
                            eventEmitter.emit(result)
                        if (reloadStore) {
                            this.LoadStepper();
                        }
                    }
                });


            },
                (err) => {
                    if (eventEmitter)
                        eventEmitter.emit(err)
                },
                () => {
                    this._store.dispatch(new SpinnerLoaded());
                    this.bookingLoading = false;
                });
        }

    }



    convertSeasonDateToDate(selectedDate) {
        var DateSpilit = selectedDate.split("-");
        var newDate = new Date(DateSpilit[0], (Number(DateSpilit[1]) - 1), DateSpilit[2]);


        //  var formartDate = new Date(DateSpilit[0]);
        var dp: DateFormat = new DateFormat('en');
        return dp.transform(newDate);
    }


    convertGetToDate(convertDate) {
        var dp: DateFormat = new DateFormat('en');
        return dp.transform(convertDate);
    }



    //Load assets
    getFacilityAndResources(_listVenuids, _listSaleCategories, _searchstring, _selectedVenue, _selectedAssetids, _From, _To, assetIds, _SelectedList) {
        let searchParam = new VenueAssetsearchparams();
        searchParam.searchpharese = this.searchstring;
        let venuid = _listVenuids.toString();
        if (venuid.length == 0) { venuid = "" }
        searchParam.listVenuids = venuid;
        searchParam.SalesCategoryId = this.clientSaleCategories.toString();
        let sFacility = _selectedAssetids.toString();
        searchParam.assetIds = assetIds
        sFacility.length == 0 ? "" : sFacility;
        searchParam.assetTypeIds = sFacility;
        searchParam.From = _From == 0 ? 0 : _From;
        searchParam.To = _To == 0 ? 0 : _To;
        // searchParam.priceConcessionIds = this.GetconcessionId();
        searchParam.bookingTypeIds = this.booking.bookingTypeId.toString();

        if (this.isRolloverBooking) {
            searchParam.page = new Page();
            searchParam.page.size = 0;
            searchParam.page.number = 0;

        }

        let listVenuids = _listVenuids.toString();
        if (this.regBookingService != null) {
            this.regBookingService.getFacilityAndResource(searchParam).safeSubscribe(this, async response => {
                console.log(response);
                if (response) {
                    this.listDataAsset = response;
                    await Promise.all(
                        _SelectedList.map(async (parent, pIndex) => {
                            var findAsset = this.listDataAsset.find(re => re.id == parent.id);
                            if (findAsset) {
                                await Promise.all(
                                    findAsset.assetList.map(async (chl, cIndex) => {
                                        var findChildren = parent.children.find(ch => ((chl.multiPurposeAssetIds ?? "") == "" ? (ch.id == chl.id) : ((ch.data?.multiPurposeAssetIds ?? "") == (chl.multiPurposeAssetIds ?? ""))));
                                        var _isMultiPurpose = (chl.multiPurposeAssetIds ?? "") != "";
                                        if (findChildren) {
                                            if (_isMultiPurpose) {

                                                await this.LoadMultipurposeData(chl.id, chl);//,chl
                                            }
                                            findChildren.data = chl;

                                            if (!_isMultiPurpose) {
                                                /*   if (this.displayFacilityConfigurations) {
                                                      this.getBookingConfiguration(_SelectedList);
                                                      findChildren.data.selectedConfigurationId = this.getSelectedConfigId(chl);
                                                      findChildren.data.selectedItem = this.getBookingSelectedItem(chl);
                                                  } */
                                            } else {
                                                findChildren.label = chl.name;
                                            }


                                        }

                                    })
                                );
                            }

                        }));

                    if (_SelectedList != undefined && _SelectedList != null && _SelectedList.length > 0) {
                        if (this.displayFacilityConfigurations) {
                            this.getBookingConfiguration(_SelectedList);
                            _SelectedList.map((parent, pIndex) => {
                                parent.children.map((findChildren, pcIndex) => {
                                    findChildren.data.selectedConfigurationId = this.getSelectedConfigId(findChildren.data);
                                    findChildren.data.selectedItem = this.getBookingSelectedItem(findChildren.data);
                                });
                            });
                        }
                        //populate multiple asset related item and configuration
                        if (this.booking.bookingPackages && this.booking.bookingPackages.length > 0) {
                            this.booking.bookingPackages.forEach((pk, i) => {
                                if (pk.bookingVenues != undefined && pk.bookingVenues.length > 0) {
                                    pk.bookingVenues.forEach((bk, pkIndex) => {
                                        //Array pushing
                                        let _selectedVenue: TreeNode;
                                        if (_SelectedList) {
                                            _selectedVenue = _SelectedList.find(sl => sl.id == bk.venue.id);
                                        };
                                        if (_selectedVenue) {
                                            //BookingItem foreach for assets
                                            bk.bookingItem.forEach((bkItem, bkindex) => {
                                                //Assets forEach
                                                if (bkItem) {
                                                    //temp fix to booking item doe snot have venue
                                                    if (bkItem.item.venue == null || bkItem.item.venue == undefined) {
                                                        bkItem.item.venue = bk.venue;
                                                    }
                                                    const _isMultiPurposeAsset = (bkItem.multiPurposeAssetIds ?? "") != "";
                                                    if (_isMultiPurposeAsset) {
                                                        let findAsset = _selectedVenue.children.find(sl => (sl.data["multiPurposeAssetIds"] ?? "") == bkItem.multiPurposeAssetIds);
                                                        if (findAsset) {
                                                            var _allConfigList = findAsset.data["MultiPurposeAssets"].flatMap(asset => asset.configuration);
                                                            if (bkItem.asset && bkItem.asset.length > 0) {
                                                                findAsset.data["selectedConfigurationId"] = bkItem.asset[0].configuration.id;
                                                                findAsset.data["selectedConfigurationName"] = _allConfigList.find(cnfg => cnfg.id == bkItem.asset[0].configuration.id)?.name;
                                                            }
                                                            findAsset.data["selectedItem"] = findAsset.data["items"].find(itm => itm.id == bkItem.item.id);
                                                        }
                                                    }
                                                    /* bkItem.asset.forEach((ast, asIndex) => {
                                                        if (ast != undefined) {


                                                        }
                                                    }); */
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                        }


                        this._store.dispatch(new StoreAssets(_SelectedList));
                        this.selectedStepIndex = 2;
                        /*if (!this.isRolloverBooking && this.bookingTypeId != '-4') {
                            this.selectedStepIndex = 2;
                        }
                        else {
                            this.selectedStepIndex = 1;
                        }*/

                    }
                }
                console.log(_SelectedList);
            });
        }


    }


    loadEventWeekViewData(event = null) {
        this.events = [];
        if (this.booking && this.booking.bookingPackages) {

            this.booking.bookingPackages.forEach((bkpkacge, bkIndex) => {
                if (bkpkacge.bookingVenues && bkpkacge.bookingVenues.length > 0) {
                    bkpkacge.bookingVenues.forEach((bkVenue, bIndex) => {
                        if (bkVenue.bookingItem && bkVenue.bookingItem.length > 0) {
                            bkVenue.bookingItem.forEach((bkItem, IIndex) => {
                                if (bkItem.id.startsWith("R")) {
                                    if (bkItem.recurrentBookingItem) {
                                        bkItem.recurrentBookingItem.forEach((recurrent, rIndex) => {
                                            let reccurentStartDate = new Date(recurrent.startDate);
                                            let reccurentEndDate = new Date(recurrent.endDate);
                                            this.getEventDataWeekView(reccurentStartDate, reccurentEndDate, bkItem, bkpkacge);

                                        })
                                    }
                                } else {

                                    let adHocStartDate = new Date(bkItem.startDate);
                                    let adHocEndDate = new Date(bkItem.endDate);

                                    this.getEventDataWeekView(adHocStartDate, adHocEndDate, bkItem, bkpkacge);



                                }
                            })

                        }

                    });
                }
            });
        }

        return this.events;
    }


    getEventDataWeekView(startDate, endDate, bkItem, bkpkacge) {
        let ev = new EventView();
        ev.startDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), 0, 0);
        ev.startTime = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate(), startDate.getHours(), startDate.getMinutes());
        ev.endTime = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate(), endDate.getHours(), endDate.getMinutes());
        ev.eventViewType = 1;
        ev.description = bkpkacge.name;
        //  ev.bookingPackageName = bkpkacge.name;
        if (bkItem.asset.length > 0) {
            ev.treeNode = new TreeNode();
            ev.treeNode.id = bkItem.asset[0].id;
            ev.treeNode.label = bkItem.asset[0].name;
        }

        this.events.push(ev);
    }


    getAllocation(assetData, _team, startTime, endTime) {
        let allocations = new Allocation();
        allocations.attendees = _team.attendees;
        allocations.id = '-1';
        allocations.timeslot = new Timeslot();
        allocations.timeslot.id = '-1';
        allocations.timeslot.asset = new Asset();
        allocations.timeslot.asset.id = String(assetData.assetId);

        var _isConfigTobeDetermined = this.checkForNullConfigurations(assetData.event.treeNode.data.selectedItem, assetData.event.treeNode.data);
        if (this.displayFacilityConfigurations && _isConfigTobeDetermined) {

            allocations.timeslot.eventConfiguration = new EventConfiguration();
            allocations.timeslot.eventConfiguration.id = String(assetData.event.treeNode.data.selectedConfigurationId);
        }




        if (assetData.event && assetData.event.treeNode.data) {
            allocations.timeslot.asset.type = assetData.event.treeNode.data.type.toLowerCase();
            if (assetData.event.treeNode.data.type.toLowerCase() == 'resource') {

                allocations.timeslot.type = 'PrivateEventResourceTimeslot';

            } else if (assetData.event.treeNode.data.type.toLowerCase() == 'brandingArea') {

                allocations.timeslot.type = 'PrivateEventBrandingAreaTimeslot';

            } else {
                allocations.timeslot.type = 'PrivateEventFacilityTimeslot';
            }
        }



        allocations.timeslot.startTime = startTime;
        allocations.timeslot.endTime = endTime;

        return allocations;
    }

    get showPrice() {
        if (this.bookingType) {
            if (this.bookingType.displayPrice == false) {
                return false;
            }
            return true;
        }
        return true;
    }


    generateBookingTeams() {

    }

    //Booking pacakage generate for rollover Booking
    getGeneratedBookingPackage(bespokePackages, teams, teamgroupType) {
        let _bookingPackage = [];
        // let bpkge = new BookingPackage();

        if (teams && teams.length > 0) {
            teams.forEach((team, index) => {
                let bpkge = new BookingPackage();
                bpkge.id = team.id;
                //bpkge.name = team.activityGroup;
                var packageDetails = bespokePackages.find(bp => bp.id == team.packageId)
                if (packageDetails) {
                    bpkge.name = packageDetails.name + " - " + team.activityGroup;
                }

                bpkge.attendees = Number(team.participants);


                if (team.id.startsWith('-')) {
                    bpkge.quantity = 1;
                    bpkge.package = new Package()
                    bpkge.package.id = team.packageId;
                    var findSeason = teamgroupType.seasons.find(s => s.id == String(this.seasonId));
                    bpkge.startDate = RegularBookingAdapter.getStartDateEndDate(findSeason.from);
                    bpkge.endDate = Utility.convertToISO(Utility.appendTimePart(moment(findSeason.to).toDate(), moment(findSeason.to).toDate(), true));
                }
                _bookingPackage.push(bpkge);
            })
        }

        //  console.log(bookingPackage);
        console.log(_bookingPackage);
        return _bookingPackage;
    }
    isQuestionAnswered(ques) {
        var isAnsweredForTheQuestion = false;
        switch (ques.type) {


            case "textQuestionAnswer":
                if (ques.answer !== '' && ques.answer != undefined) {
                    isAnsweredForTheQuestion = true
                }
                break;

            case "richTextQuestionAnswer":
                if (ques.answer !== '' && ques.answer != undefined) {
                    isAnsweredForTheQuestion = true
                }
                break;
            case "booleanQuestionAnswer":
                if (ques.answer != undefined) {
                    isAnsweredForTheQuestion = true
                }

                break;

            case "singleChoiceQuestionAnswer":
                if (ques.bookingAnswerChoice != undefined) {
                    isAnsweredForTheQuestion = true
                }

                break;


            case "multipleChoiceQuestionAnswer":
                if (ques.bookingAnswerChoice != undefined && ques.bookingAnswerChoice.length > 0) {
                    if (ques.question.quantityRequired) {
                        isAnsweredForTheQuestion = true;
                        ques.bookingAnswerChoice.forEach(function (bac) {
                            if (bac.quantity == undefined || bac.quantity == 0 || bac.quantity == "") {
                                isAnsweredForTheQuestion = false;
                            }
                        });

                    } else {
                        isAnsweredForTheQuestion = true
                    }
                }
                break;
            default:
                isAnsweredForTheQuestion = true;

        }
        return isAnsweredForTheQuestion;
    }

    populateSetupTime(venueId, assetId, alldata) {
        let res
        var assetList = this.rbStoreData.AssetList;


        var selectedVenue = assetList.find(a => a.id == venueId);
        var selectedFacility = selectedVenue.children.find(ch => ch.id == assetId || (ch.data["multiPurposeAssetIds"] == alldata.multiPurposeAssetIds));
        this.assetDataFromStore = selectedFacility.data as any;


        var _config = RegularBookingAdapter.selectConfiguration(this.assetDataFromStore, this.displayFacilityConfigurations);

        if (_config != null) {

            res = {
                setupTime: _config.setupTime ? _config.setupTime : 0,
                tearDownTime: _config.teardownTime ? _config.teardownTime : 0
            }
        }

        return res;
    }

    get getSalesCateGoriesIdList() {
        let _salesCatList = [];
        if (this.booking && this.booking.bookingPackages) {
            this.booking.bookingPackages.forEach((bk, bkIndex) => {
                if (bk.salesCategories) {
                    bk.salesCategories.forEach((s, sIndex) => {
                        if (s.id) {
                            let findDuplicate = _salesCatList.find(sl => sl == s.id);
                            if (!findDuplicate) {
                                _salesCatList.push(s.id);
                            }
                        }
                    });
                }
            });
        };
        return _salesCatList.join();
    }


    GetconcessionId() {
        var concessionId;
        if (this.clientPriceConcessionId) {
            concessionId = this.clientPriceConcessionId;
        }
        else {
            var _regularXmlData = (environment.RegularBookingSetting as RegularBookingSettings)
            var _BookingTypedefaultConcessionId = _regularXmlData.booking.bookingTypes.find(bk => bk.id == this.bookingType.id).defaultPriceConcessionId;
            concessionId = _BookingTypedefaultConcessionId;
        }

        return concessionId;
    }

    // XML SETTING FOR Facility Configuration
    FacilityConfiguration() {
        if (this.bookingType) {
            var _regularXmlData = (environment.RegularBookingSetting as RegularBookingSettings);
            var _filteredBookingType = _regularXmlData.booking.bookingTypes.find(x => x.id == this.bookingType.id);
            if (_filteredBookingType != undefined) {
                this.displayFacilityConfigurations = _filteredBookingType.displayFacilityConfigurations;
            }
        }
    }

    public getTabIndexByName(tabName: string): number {

        var _stepperIndex: number = 0;

        if (this.bookingType) {
            if (tabName === 'Date & Time') {
                _stepperIndex = (this.bookingType.id == -4 ? 1 : 2);
            }
            else if (tabName === 'Questionnaire') {
                _stepperIndex = (this.bookingType.id == -4 ? 2 : 3);
            }
            else if (tabName === 'Documents') {
                _stepperIndex = (this.bookingType.id == -4 ? 3 : 4);
            }
            else if (tabName === 'Submit Application') {
                _stepperIndex = (this.bookingType.id == -4 ? 4 : 5);
            }
        }

        return _stepperIndex;
    }




    cacheLocations(_listVenuids, _listSaleCategories, _searchstring, _selectedVenue, _assetTypeIds, _From, _To, callBack: (thisComponent: any) => void = null, locationPage: Page = null, pageEvent: PageEvent = null) {

        let searchParam = new VenueAssetsearchparams();
        searchParam.searchpharese = this.searchstring;
        let venuid = _listVenuids.toString();
        if (venuid.length == 0) { venuid = "" }
        searchParam.listVenuids = venuid;
        searchParam.assetIds = "";
        searchParam.SalesCategoryId = this.getSalesCateGoriesIdList
        let sFacility = _assetTypeIds.toString();
        sFacility.length == 0 ? "" : sFacility;
        searchParam.assetTypeIds = sFacility;
        searchParam.From = _From == 0 ? 0 : _From;
        searchParam.To = _To == 0 ? 0 : _To;
        searchParam.priceConcessionIds = this.GetconcessionId();
        searchParam.bookingTypeIds = this.bookingTypeId;

        let listVenuids = _listVenuids.toString();
        this._store.dispatch(new SpinnerLoading());

        this._assetService.getFacilityAndResource(searchParam).safeSubscribe(this, res => {

            var _listData: any;
            _listData = res;
            var _children = [];
            var _newSelectedList = [];

            if (_listData.length > 0) {
                for (var i = 0; i < _listData.length; i++) {
                    for (var x = 0; x < _listData[i].assetList.length; x++) {
                        _children.push({ 'children': _listData[i].assetList[x].assetList, 'data': _listData[i].assetList[x], 'id': _listData[i].assetList[x].id, 'label': _listData[i].assetList[x].name, 'parentId': _listData[i].id, 'selectable': true });
                    }
                    _newSelectedList.push({ 'children': _children, 'data': null, 'id': _listData[i].id, 'label': _listData[i].name, 'parentId': null, 'selectable': false });
                    _children = [];
                }

                var selectedList = _newSelectedList;

                cacheUtility.pushToCache(selectedList, this.booking.id);

                this._store.dispatch(new StoreAssets(selectedList));
                if (callBack != null) {
                    callBack(this);
                }
            }
            this._store.dispatch(new SpinnerLoaded());
        }, error => {
            this._store.dispatch(new SpinnerLoaded());
        },
        );
    }

    NavigateStepperAfterCacheAssets(thisComponent) {
        thisComponent.selectedStepIndex++;
    }



    GetConfigsTobeListed(data: Facility, itemList: Items[], _configuration, child = null) {
        this.configurationToBeListed = [];
        let _isMultipurpose = false;

        if ((data as any).multiPurposeAssetIds != undefined && (data as any).multiPurposeAssetIds != "") {
            _isMultipurpose = true;
        }
        data.items.forEach((item, itemIndx) => {
            var _getItem = itemList.find(resp => resp.id == item.id);
            ///* var _getItem --> items which are commonly there in both item search API result and facility search API result
            if (_getItem) {
                if (_getItem.id == item.id) {
                    //this.configurationToBeListed = [];

                    if (!this.checkForNullConfigurations(_getItem, data)) {
                        //  data.isConfigTobeDetermined = false;
                        _getItem.itemAssets.forEach((itmAst, itemAssetIndx) => {

                            _configuration = data.configuration.find(resp => resp.id == itmAst.configuration.id);
                            ///* _configuration --> configurations which are there in facility level configuration and item's, itemAsset's configuration

                            if (_configuration != undefined) {
                                if (this.configurationToBeListed.length > 0) {
                                    var isAdded = this.configurationToBeListed.find(con => _isMultipurpose ? (con.name == _configuration.name) : (con.id == _configuration.id));
                                    if (!isAdded) {
                                        this.configurationToBeListed.push(_configuration);
                                    }
                                }
                                else {
                                    this.configurationToBeListed.push(_configuration);
                                }
                                this.configurationToBeListed = [...this.configurationToBeListed].sort((a, b) =>
                                    a.name.localeCompare(b.name)
                                );
                                data.configurationToBeListed = this.configurationToBeListed;
                            }
                        })
                    }
                    //sort

                    this.getDefaultSelectedConfig(data);
                    //get selected item id
                    //this.getSelectedItem(data, itemList, child); mpve to calling place
                }
            }
        })

    }

    checkForNullConfigurations(Item, FacilityData: Facility) {
        var _nullConfigItem = Item.itemAssets.find(itm => itm.configuration ? itm.configuration.id == "" : false);
        if (_nullConfigItem) {
            this.configurationToBeListed = [];
            //this.configurationToBeListed.push(data.configuration);
            // this.configurationToBeListed = FacilityData.configuration;
            FacilityData.configurationToBeListed = this.configurationToBeListed = FacilityData.configuration;;
            // FacilityData.isConfigTobeDetermined = true;
            return true;
        }
        return false;
    }

    getSelectedItem(data: Facility, responseData, child = null) {

        //filter Item for the selected facility

        let _facilityItems = responseData.filter(item => data.items.findIndex(fi => fi.id == item.id) >= 0);
        if (_facilityItems.length > 0) {

            var configId = data.selectedConfigurationId ? data.selectedConfigurationId : data.defaultSelectedConfigId;
            if ((data as any).multiPurposeAssetIds != undefined && (data as any).multiPurposeAssetIds != "") {
                data.selectedConfigurationName = data.configuration.find(resp => Number(resp.id) == Number(configId))?.name.trim();
                data.items = _facilityItems;
            } else {
                _facilityItems.forEach((resData, indx) => {
                    resData.itemAssets.forEach((itemAsset, itemAssetIndx) => {
                        if (itemAsset.configuration.id == configId) {
                            data.selectedItem = resData;
                            //if (child) {
                            //    child.selectedItem = resData;
                            //}
                        }
                    })

                    if (!data.selectedItem) {
                        let _itemsWithNullConfigurations = resData.itemAssets.filter(e => e.configuration.id == "");
                        if (_itemsWithNullConfigurations.length > 0)
                            data.selectedItem = _facilityItems[0];
                        //if (child) {
                        //    child.selectedItem = resData;
                        //}
                    }
                })
            }
        }
    }

    getDefaultSelectedConfig(FacilityData: Facility) {

        let _configurations = FacilityData.configurationToBeListed ? FacilityData.configurationToBeListed : FacilityData.configuration;

        //if (FacilityData.configurationToBeListed.length > 0) {

        //get internet default configuration
        var _internetDefaultConfig = _configurations.find(resp => resp.internetDefault == true);

        //get default configuration
        var _defaultConfig = _configurations.find(resp => resp.default == true);

        //get configuration from item assets
        var _firstItemConfig = _configurations[0];

        // assign default configuration id to defaultSelectedConfigId
        FacilityData.selectedConfigurationName = _internetDefaultConfig ? _internetDefaultConfig.name : (_defaultConfig ? _defaultConfig.name : _firstItemConfig.name);
        return FacilityData.defaultSelectedConfigId = _internetDefaultConfig ? _internetDefaultConfig.id : (_defaultConfig ? _defaultConfig.id : _firstItemConfig.id);

        // }
    }


    getBookingConfiguration(_SelectedList = null) {

        var venueId;
        let childerenDataArray;
        var itemConfigurationId;
        var assetId;
        var configurationId;



        this.SelectedList = _SelectedList && _SelectedList.length > 0 ? _SelectedList : this.rbStoreData.AssetList;
        var booking = this.booking;
        var bookingPackage = this.booking.bookingPackages;


        bookingPackage.forEach((pck, indx) => {
            if (pck.bookingVenues.length > 0) {
                pck.bookingVenues.forEach((bookingVenuesChild, index) => {
                    venueId = bookingVenuesChild.venue.id;

                    bookingVenuesChild.bookingItem.forEach((bookingItemchild, indx) => {
                        bookingItemchild.asset.forEach((assetChild, indx) => {
                            var _isMultiPurpose = (bookingItemchild.multiPurposeAssetIds ?? "") != "";
                            assetId = assetChild.id;
                            configurationId = assetChild.configuration.id;

                            this.SelectedList.forEach((SelectedListChild, indx) => {
                                //assert list inside level
                                if (SelectedListChild.id == venueId) {
                                    SelectedListChild.children.forEach((childrenData, indx) => {
                                        if ((_isMultiPurpose && bookingItemchild.multiPurposeAssetIds == (childrenData.data["multiPurposeAssetIds"] ?? "")) || (!_isMultiPurpose && childrenData.id == assetId)) {
                                            childerenDataArray = childrenData.data;

                                            if (childerenDataArray && childerenDataArray.configuration) {
                                                childerenDataArray.configuration.forEach((configurationData, indx) => {
                                                    if (configurationData.id == configurationId) {
                                                        let isAdded = this.configurations.find(y => y.configId == configurationId);

                                                        if (!isAdded) {
                                                            let config = {
                                                                assertId: assetId,
                                                                itemId: bookingItemchild.item.id,
                                                                item: bookingItemchild.item,
                                                                configId: Number(configurationId),
                                                                configName: configurationData.name
                                                            }
                                                            this.configurations.push(config);
                                                        }
                                                    }
                                                })
                                            }
                                        }
                                    })
                                }

                            })

                        })
                    })
                })
            }
        })
        this.configurationToBeListed = [...this.configurationToBeListed].sort((a, b) =>
            a.name.localeCompare(b.name)
        );

        return this.configurations;
    }

    getSelectedConfigId(asset) {
        var _selectedConfigId;
        if (asset.selectedItem) {
            var _selectedConfig = this.configurations.find(x => x.item.id == Number(asset.selectedItem.id));
            if (_selectedConfig) {
                _selectedConfigId = _selectedConfig.configId;
            }
        }
        return _selectedConfigId;
    }

    getBookingSelectedItem(asset) {

        var _selectedItem;
        if (asset.selectedItem) {
            var _selectedConfig = this.configurations.find(x => x.item.id == Number(asset.selectedItem.id));
            if (_selectedConfig) {
                _selectedItem = _selectedConfig.item;
            }
        }
        return _selectedItem;
    }

    isSelectedAsset(data) {

        var _isfacilitySelected = false;
        this.venueList.forEach(venue => {
            venue.children.forEach(child => {
                if (child.data == data.id) {
                    _isfacilitySelected = true;
                }

            });
        });

        return _isfacilitySelected;
    }




    //multipurpose asset handling
    GetItemIdList(list) {
        const ids = list.flatMap(x => x.items.map(k => k.id));
        return [...new Set(ids)];
    }

    async LoadMultipurposeData(id, assets) {
        assets.MultiPurposeAssets = [];

        const results = await this.getMultiFacilityAndResource(id, assets.multiPurposeAssetIds, '', 0, 0);
        try {
            assets.MultiPurposeAssets = results;
            //   mainAsset.MultiPurposeAssetList = [];
            // mainAsset.MultiPurposeAssetList.push(results);

            let ItemListId = this.GetItemIdList(results);
            var _regularXmlData = (environment.RegularBookingSetting as RegularBookingSettings);
            var _BookingTypedefaultConcessionId = _regularXmlData.booking.bookingTypes.find(bk => bk.id == this.bookingType.id).defaultPriceConcessionId;

            var itemSearchParam = new ProductItemFilters();
            itemSearchParam.ItemIds = ItemListId.join();
            itemSearchParam.SalesChannelId = 5;
            if (this.contact.client.priceConcessionId) {
                itemSearchParam.PriceConcessionId = this.contact.client.priceConcessionId;
            } else {
                itemSearchParam.PriceConcessionId = _BookingTypedefaultConcessionId;
            }
            // Wrap itemSearch in a Promise
            let itemSearchResult: any[] = await new Promise((resolve, reject) => {
                this.regBookingService.itemSearch(itemSearchParam).safeSubscribe(this, (res: any) => {
                    var itemsList = RegularBookingAdapter.PopulateItemsPrice(res, this.clientPriceConcessionId, Number(_BookingTypedefaultConcessionId));

                    resolve(res);
                }, (err: any) => {
                    reject(err);
                });
            });

            itemSearchResult = [...itemSearchResult].sort((a, b) =>
                a.name.localeCompare(b.name)
            );
            // mainAsset.ItemDetails = itemSearchResult;
            assets.items = itemSearchResult;
            this.GetConfigsTobeListed(assets, itemSearchResult, null, null);
            /*  this.regBookingService.itemSearch(itemSearchParam).safeSubscribe(this, res => {
                 //this.itemDetails = res;
                 mainAsset.ItemDetails = res;
                 assets.items = res;//this.itemDetails;
             }); */
        } catch (error) {
            //assets.MultiPurposeAssets = [];
        }
    }

    getMultiFacilityAndResource(_selectedVenue, assetIds, _assetTypeIds, _From, _To, locationPage: Page = null): Promise<any[]> {
        return new Promise((resolve, reject) => {
            let searchParam = new VenueAssetsearchparams();
            searchParam.searchpharese = "";
            searchParam.SalesCategoryId = "";
            let venuid = _selectedVenue.length > 0 ? _selectedVenue.toString() : '';
            searchParam.listVenuids = venuid;
            searchParam.assetIds = assetIds;
            let sFacility = _assetTypeIds.toString();
            searchParam.assetTypeIds = sFacility.length == 0 ? '' : sFacility;
            searchParam.From = _From == 0 ? 0 : _From;
            searchParam.To = _To == 0 ? 0 : _To;
            searchParam.page = new Page();
            searchParam.page.number = 0;//(locationPage == null) ? this.pagenumber : locationPage.number;
            searchParam.page.size = 100;//(locationPage == null) ? 0 : locationPage.size;
            searchParam.priceConcessionIds = this.GetconcessionId();
            searchParam.bookingTypeIds = this.booking.bookingTypeId.toString();

            this._assetService.getFacilityAndResource(searchParam).safeSubscribe(this, res => {
                if (res && res.data) {
                    resolve(res.data[0].assetList);
                } else {
                    resolve([]);
                }
            }, err => {
                reject(err);
            });
        });
    }


}



